export const normalizeDate = (dateStr: string | null, opts?: { endOfDay?: boolean }): string | null => {
  if (!dateStr) return null;

  const [datePart] = dateStr.split('T');

  return opts?.endOfDay ? `${datePart}T23:59:59.999Z` : `${datePart}T00:00:00.000Z`;
};
